import AuthService from '@/services/auth.service'

export const stompMixin = {
  destroyed () {
    this.$stompService.disconnect()
  },
  watch: {
    currentUser (newUser, oldUser) {
      this.wsUserChanged(newUser, oldUser)
    },
    portalNotifs (n, o) {
      const notif = this.portalNotifs.pop()
      const payload = { message: notif.txt, title: 'Portal Info' }
      if (notif.st !== 0) {
        payload.variant = 'danger'
        payload.title = 'Portal Error'
        payload.message = notif.error
      }
      this.toaster(payload)
    },
    adminNotifs (n, o) {
      const notif = this.adminNotifs.pop()
      const payload = { message: notif.txt, title: 'Admin Info' }
      if (notif.st !== 0) {
        payload.variant = 'danger'
        payload.title = 'Admin Error'
        payload.message = notif.error
      }
      this.toaster(payload)
    },
    userNotifs (n, o) {
      const vm = this
      const notif = vm.userNotifs.pop()

      const payload = { message: notif.txt, title: 'User Info' }
      if (notif.st !== 0) {
        payload.variant = 'danger'
        payload.title = 'User Error'
        payload.message = notif.error
      }

      if (vm.currentUser !== null) {
        if (notif.op === 'logout' && notif.usr === vm.currentUser.username) {
          if (!notif.sessionRef) {
            console.log('Web Socket logout', vm.currentUser.username)
            AuthService.localLogout()
          } else {
            const sessionRef = vm.currentUser.sessionRef
            if (sessionRef === notif.sessionRef) {
              console.log('Web Socket logout with session reference for', vm.currentUser.username)
              // vm.toaster({ message: 'You have been logged out! You will be automatically redirected in 5 seconds', variant: 'danger', title: 'Logout' })
              // setTimeout(() => AuthService.localLogout(), 5000)
              AuthService.localLogout()
            } else {
              vm.toaster({ message: ('Logged out from session: ' + notif.sessionRef), variant: 'warning', title: 'Logout' })
            }
          }
        }

        if (notif.op === 'pong' && notif.usr === vm.currentUser.username && notif.sessionRef === vm.currentUser.sessionRef) {
          this.$store.commit('auth/resetSessionTimer')
        }
      }

      vm.toaster(payload)
    }
  },
  computed: {
    portalNotifs () {
      return this.$store.getters['stomp/portalNotifs']
    },
    adminNotifs () {
      return this.$store.getters['stomp/adminNotifs']
    },
    userNotifs () {
      return this.$store.getters['stomp/userNotifs']
    }
  },
  methods: {
    /** start stomp (web socket) methods */
    wsUserMsgHandler (jsonMsg) {
      this.$store.commit('stomp/receiveUserMsg', jsonMsg)
    },
    wsPortalMsgHandler (jsonMsg) {
      // console.debug('[Web Socket]', 'Vue Portal handler got message:', jsonMsg)
      this.$store.commit('stomp/receivePortalMsg', jsonMsg)
    },
    wsAdminMsgHandler (jsonMsg) {
      // console.debug('[Web Socket]', 'Vue Admin handler got message:', jsonMsg)
      this.$store.commit('stomp/receiveAdminMsg', jsonMsg)
    },
    wsErrorHandler (error) {
      console.warn('[Web Socket]', 'Connection error')
      console.error(error)
      setTimeout(this.wsConnect, 3000)
      console.warn('STOMP: Reconnecting in 3 seconds')
    },
    async wsUserChanged (newUser, oldUser) {
      try {
        if (!newUser && this.$stompService.isConnected()) {
          this.$stompService.disconnect()
          // console.debug('[Web Socket] ', 'Disconnecting stompService - no user')
          return
        }

        let userChanged = false
        if (!oldUser && newUser.username) {
          userChanged = true
        } else {
          // userChanged = true // to reconnect and update bearer header
          if (newUser) {
            userChanged = newUser.username !== oldUser.username
          }
        }

        // console.debug('[Web Socket] ', 'User changed', userChanged)
        if (userChanged && this.$stompService.isConnected()) {
          // console.debug('[Web Socket] ', 'User changed => disconnecting StompService')
          this.$stompService.disconnect()
          // console.debug('[Web Socket] ', 'User changed => reinitializing StompService')
          this.$stompService.init()
        }

        if (userChanged) {
          this.wsConnect(newUser)
        }
      } catch (e) {
        console.error('Error connecting to stomp server', e)
      }
    },
    wsConnect (user = null) {
      if (!user) {
        user = this.currentUser
      }
      if (user) {
        // console.debug('[Web Socket] ', 'Connecting user to topics', user)
        const topicConfig = {
          errorHandler: this.wsErrorHandler,
          userHandler: this.wsUserMsgHandler,
          portalHandler: this.wsPortalMsgHandler
        }
        const ADMIN_ROLE = process.env.VUE_APP_ADMIN_ROLE
        if (user.roles.includes(ADMIN_ROLE)) {
          topicConfig.adminHandler = this.wsAdminMsgHandler
        }

        // console.debug('[Web Socket] ', 'Connecting user to topics', 'username:', user.username, 'headers:', topicConfig.headers)
        this.$stompService.connectUser(topicConfig)
      }
    },
    toaster (props) {
      this.makeToast(props.message, props.title || 'Info', props.variant || 'primary', 3000)
    }
    /** end stomp (web socket) methods */
  }
}
